export const getLeaveStats = (
  leaveData = []
) => {
  const totalApproved =
    leaveData.filter(
      (leave) => leave.is_approved
    ).length;

  return {
    totalApproved,
  };
};